// https://signagedisplay.optigoapps.com/?device_token=KTWWYQ6KU71EL5YD&SV=1
// https://testtvt.optigoapps.com/?device_token=KTWWYQ6KU71EL5YD&SV=1
// http://localhost:3000/?device_token=J3X6J1I331B7501R&SV=0

import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TvScreenSlider from "./componets/TvScreenSlider/TvScreenSlider";
import AccountDeleteStep from "./componets/AccountDelete/AccountDeleteStep";
import PrivacyPolicy from "./componets/PrivacyPolicy/PrivacyPolicy";
import Support from "./componets/Support/Support";
import { DeviceStatusProvider } from "./DeviceStatusContext";
import ConnectionManager from "./API/SoketConnection/ConnectionManager";
import { CallApi } from "./API/CallApi/CallApi";

const App = () => {
  const [deviceToken, setDeviceToken] = useState(null);
  const [isReady, setIsReady] = useState(false); 

  useEffect(() => {
    const init = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const token = queryParams.get("device_token");
      const SV = queryParams.get("SV");
      if (token) {
        sessionStorage.setItem("device_token", token);
        setDeviceToken(token);
      }

      if (SV) {
        sessionStorage.setItem("SV", SV);
      }

      const body = {
        con: "{\"id\":\"\",\"mode\":\"DeviceStatus\",\"y\":\"\",\"appuserid\":\"\",\"IPAddress\":\"\"}",
        p: '{"AppId":"4"}',
        f: "(TvSetContentSoket)",
      };

      try {
        const response = await CallApi(body);
        if (response?.rd?.[0]) {
          sessionStorage.setItem(
            "soketVariable",
            JSON.stringify(response.rd[0])
          );
        }
      } catch (err) {
        console.error("Socket config load failed", err);
      }
      setIsReady(true);
    };

    init();
  }, []);

  if (!isReady) return null;

  return (
    <DeviceStatusProvider>
      <BrowserRouter>
        <ConnectionManager />
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/steps-account-delete" element={<AccountDeleteStep />} />
          <Route path="/Support" element={<Support />} />

          <Route
            path="/"
            element={
              deviceToken ? (
                <TvScreenSlider />
              ) : (
                <Navigate to="/unauthorized" replace />
              )
            }
          />

          <Route
            path="/unauthorized"
            element={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "90vh",
                }}
              >
                ❌ Missing or Invalid Device Token
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </DeviceStatusProvider>
  );
};

export default App;


// basename="/signagedisplay"
// "homepage": "/signagedisplay",
